import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button } from '@mui/material';
import { memo, useCallback } from 'react';
import { ButtonAnimation } from './style';
import { ComponentStories } from 'entities/stories/ui';
import { isSmallUI } from 'shared/app/lib/choose-ui-type';
import ButtonRadius from 'console/left-menu/header/button-stories/radius-animation.svg';
import { useBooleanState } from 'shared/hooks/state/boolean';
import { useMutationCallback } from 'shared/api/hooks';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { noop } from 'ts-essentials';
export const ButtonSvgAnimation = memo(function ButtonSvgAnimation(props) {
    const { children, var_svg, ...rest } = props;
    const new_ids = useAppSelector((state) => state.ui_stories_ids?.new_ids);
    const viewed_ids = useAppSelector((state) => state.ui_stories_ids?.viewed_ids);
    const is_small_ui = isSmallUI();
    const [run, isLoading, response, error] = useMutationCallback('get_ui_stories');
    const [story_window_open, setStory_window_close, setStory_window_open] = useBooleanState(false);
    const showAnimationStories = !!(new_ids?.length || viewed_ids?.length);
    const onCLickStory = useCallback(() => {
        if ((new_ids && new_ids?.length > 0) ||
            (viewed_ids && viewed_ids?.length > 0)) {
            return setStory_window_open();
        }
        return noop();
    }, [viewed_ids, new_ids]);
    return (_jsxs(_Fragment, { children: [showAnimationStories ? (var_svg ? ( //два разных отображения: овальная анимация или круглая
            _jsxs(Button, { ...rest, onClick: onCLickStory, title: 'Публикации', children: [_jsx(ButtonRadius, { style: {
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            width: '100%',
                            height: '100%',
                        } }), children] })) : (_jsx(ButtonAnimation, { onClick: onCLickStory, children: children }))) : (children), story_window_open && (_jsx(ComponentStories, { is_small_ui: is_small_ui, open: story_window_open, close: setStory_window_close, response: response, request_error: error, loading_request: isLoading, run: run, ids_stories: [
                    ...new_ids,
                    ...viewed_ids,
                ] }))] }));
});
